import React from 'react';
import { MaskedTextInput, FieldWrapper } from '@td-client-frontend/common';
import ComponentWrapperRHF from './ComponentWrapperRHF';

interface Props {
  name: string;
  label?: string;
  placeholder?: string;
  additionalClasses?: string;
  required?: boolean;
  requiredIf?: string[];
}

export const MaskInputRhf = ({ ...props }: Props) => {
  return (
    // @ts-ignore
    <ComponentWrapperRHF {...props}>
      <MaskInput />
    </ComponentWrapperRHF>
  );
};

const MaskInput = ({ isError, error, label, additionalClasses, ...props }) => {
  return (
    <FieldWrapper label={label} isError={isError} error={error} additionalClasses={additionalClasses}>
      <MaskedTextInput {...props} isError={isError} />
    </FieldWrapper>
  );
};
